import { render, staticRenderFns } from "./BiAdjustments.vue?vue&type=template&id=f6d8d938&scoped=true&"
import script from "./BiAdjustments.vue?vue&type=script&lang=js&"
export * from "./BiAdjustments.vue?vue&type=script&lang=js&"
import style0 from "./BiAdjustments.vue?vue&type=style&index=0&id=f6d8d938&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d8d938",
  null
  
)

export default component.exports